// Ansible managed

export const env = 'prd';
export const apiHost = 'https://most.macmillan-platform.com/api/v1/';
export const supportEmail = 'most-support@macmillan.com';
export const privacyLink = 'https://us.macmillan.com/privacy-notice';
